import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import FeaturesPageHeaderMeta from './FeaturesPageHeaderMeta';
import PageTitle from '@/components/PageTitle/PageTitle';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

const FeaturesPage = () => {
    return (
        <StyledPageContainer>
            <FeaturesPageHeaderMeta />
            <PageTitle title={<FormattedMessage id="features_and_services" />} />
            <div>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="feature_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="live_bidding" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="live_bidding_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="absentee_bidding" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="absentee_bidding_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="auctioneer_dashboard" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="auctioneer_dashboard_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="our_network" />
                </Text>
                <p>
                    <FormattedMessage id="our_network_blurb" />
                </p>
                <StyledNetworkImage>
                    <img
                        alt="Our network"
                        src="https://images.liveauctioneers.com/static/network.jpg"
                    />
                </StyledNetworkImage>
                <Text h5>
                    <FormattedMessage id="catalog_set_up" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="catalog_set_up_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="bidder_management" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="bidder_management_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="inbox_messaging" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="inbox_messaging_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="statistics_tracking" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="statistics_tracking_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="self_service_upload" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="self_service_upload_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="automated_online_console" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="automated_online_console_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="end_of_auction_report" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="end_of_auction_report_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="live_items_widget" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="live_items_widget_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="qr_code" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="qr_code_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="staff_permission_levels" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="staff_permission_levels_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="weekly_newsletter" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="weekly_newsletter_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="help_files" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="help_files_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="bidder_contact_and_invoicing" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="bidder_contact_and_invoicing_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="paypal" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="paypal_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="accounting" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="accounting_blurb" />
                </StyledFeaturesBlurb>

                <Text h5>
                    <FormattedMessage id="white_label_platform" />
                </Text>
                <StyledFeaturesBlurb>
                    <FormattedMessage id="white_label_platform_blurb" />
                </StyledFeaturesBlurb>
            </div>
        </StyledPageContainer>
    );
};

export default FeaturesPage;

const StyledPageContainer = styled.div`
    max-width: ${({ theme }) => theme.breakpoints.pageWidth};
    margin: 0 auto;
    padding: 0 20px 30px;

    h2 {
        padding-top: 30px;
        padding-bottom: 18px;
    }
`;

const StyledFeaturesBlurb = styled.p`
    padding-bottom: 15px;
`;

const StyledNetworkImage = styled.div`
    text-align: center;
    padding-bottom: 15px;

    img {
        width: 100%;
        max-width: 700px;
    }
`;
